<div class='text-center thank-you-page-container'>

  <!-- Spinner durante il caricamento -->
  <div *ngIf='isLoading' class='loading-container'>
    <mat-spinner></mat-spinner>
    <p class='loading-message'>In attesa di risposta...</p>
  </div>

  <!-- Contenuto pagamento -->
  <ng-container *ngIf='!isLoading'>
    <img
      *ngIf='paymentImageSrc'
      [src]='paymentImageSrc' class='roll-in-blurred-right' />

    <p
      *ngIf='paymentMessage'
      [innerHtml]='paymentMessage'></p>
  </ng-container>

</div>
